import styled from "styled-components";

const S = {
  Buttonswrap: styled.div`
     /* width: 516px; */
                  height: auto;
                  /* margin: 0px auto; */
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  .buttons{
                    height: auto;
                    margin:0px 10px;
                    float: left;
                    display: table;
                    background-color: #19B5FE;
                    border-radius: 8px;
                    border:none;
                    font-weight: bold;
                    color:white;
                    padding: 10px;
                    transition: 500ms;
                    cursor:pointer;
                    &:hover{
                      background-color: rgba(28,214,124,1);
                      transition: 500ms;
                    }
                    &:disabled{
                      background-color: grey;
                      opacity: 0.3;
                      cursor:no-drop;
                    }
                    svg{
                      margin-right: 10px;
                    }
                  }
    `
}

export default S